/**
 * defa.views.ClaimForwardEmailForm
 * A view for forwarding a Unit to a Customer by email.
 * @version 1.2.0
 */
import Form     from 'scripts/poppet/form';
import template from 'templates/claimForwardEmailForm.jst.html';

const selectors = {
	inputEmail: '[data-input=forward-email]',
};

const ClaimForwardEmailForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	ui: {
		email: selectors.inputEmail,
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Send the form.
	 * @void
	 */
	submit: function () {
		let email = this.ui.email.val().trim();
		this.trigger( 'claim:forwardEmail', email );
	},
	
} );

export default ClaimForwardEmailForm;